import axiosHttp from 'axios'
import { trimPath, getEnv, redirectToLogin } from '../helpers/functions'
import { snackActions } from '../config/snack-actions'

const apiUrl = getEnv('REACT_APP_API_URL')

const http = axiosHttp.create({
    baseURL: apiUrl,
    validateStatus: status => status >= 200 && status < 300,
})

http.interceptors.response.use(
    response => {
        return response
    },
    error => {
        const httpStatus = error?.response?.status
        const props = error?.response?.data

        if (error.response) {
            if (error.response.status === 401 && !error.response.config.url.includes('logout')) {
                redirectToLogin()
            }
        }

        if (httpStatus === 500) {
            handleEnqueueSnackbar(snackActions.notify, 'Server error. Please contact support', false)
        }

        if (httpStatus === 400) {
            if (props.message) {
                handleEnqueueSnackbar(snackActions.notify, props.message, false)
            }
        }

        throw error
        //return { error: { data: props, status: httpStatus } }
    }
)

export const axiosBaseQuery = async ({ url, method, data, params }) => {
    try {
        const result = await http({ url: url, method, data, params, headers: getHeaders() })

        if (result?.data?.status === false && 'message' in result?.data && !result?.data?.code) {
            handleEnqueueSnackbar(snackActions.notify, result.data.message, false)
        }

        return { data: result?.data }
    } catch (error) {
        const httpStatus = error.response.status
        const props = error.response.data

        return { error: { data: props, status: httpStatus } }
    }
}

export const handleEnqueueSnackbar = (enqueueSnackbar, message, status = 'success', options = {}) => {
    if (message === undefined || !message || message === '') return

    let variant = status
    if (typeof status === 'boolean') {
        variant = status ? 'success' : 'error'
    }
    Object.assign(options, {
        variant: variant,
        autoHideDuration: 6000,
        anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
    })
    enqueueSnackbar(message, options)
}

export async function getRequest(url, params = {}) {
    return new Promise((resolve, reject) => {
        http.get(prepareRequestUrl(url), {
            headers: getHeaders(),
            params: params,
            responseType: 'json',
        })
            .then(result => {
                if ('error' in result) {
                    reject(result?.error?.data)
                }

                resolve(result?.data)
            })
            .catch(error => {
                reject(error?.response)
            })
    })
}

export async function dwnRequest(url, params = {}, api = true) {
    const resp = await http.get(prepareRequestUrl(url), {
        headers: getHeaders(),
        params: params,
        responseType: 'blob',
        baseURL: api ? apiUrl : getEnv('REACT_APP_API_HOSTNAME'),
    })

    return resp
}

export async function postRequest(url, data = {}, params = {}) {
    const result = await http.post(prepareRequestUrl(url), data, {
        headers: {
            ...getHeaders(data?.token),
            ...(params?.headers || {}),
        },
    })

    if ('error' in result) {
        throw result?.error?.data
    }

    return result?.data
}

export async function deleteRequest(url) {
    return new Promise(function (resolve, reject) {
        return http
            .delete(prepareRequestUrl(url), {
                headers: getHeaders(),
            })
            .then(result => {
                if ('error' in result) {
                    reject(result?.error?.data)
                }

                resolve(result?.data)
            })
    })
}

export const prepareRequestUrl = url => {
    return `/${trimPath(url)}`
}

export const getHeaders = (token = '') => {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
    }

    let apiToken = token || localStorage.getItem('api_token')

    if (apiToken) {
        Object.assign(headers, {
            Authorization: 'Bearer ' + apiToken,
        })
    }

    return headers
}

export default http
